// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605271133/js/" + chunkId + "." + {"44":"9fbce9c6","225":"81b38481","481":"02bdb1b1","486":"6ecc260e","770":"53e3ce7d"}[chunkId] + ".0.9880230954040051.chunk.js";
};